import { Component, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { NotificationType } from 'common/common/constants/notification-type.enum';
import { NotificationBarService } from 'shared/services/notification/notification-bar.service';
import { notificationAnimation } from 'components/notification-bar/animation/notification-animation';
import { BcNotification } from 'components/notification-bar/notification';

@Component({
  selector: 'app-notification-bar',
  templateUrl: './notification-bar.component.html',
  styleUrls: ['./notification-bar.component.scss'],
  animations: [notificationAnimation],
  encapsulation: ViewEncapsulation.None
})
export class NotificationBarComponent {
  public notifications: BcNotification[] = [];

  constructor(private _notificationService: NotificationBarService,
              private _changeDetector: ChangeDetectorRef) {
    this._setCollection();

    this._notificationService.setOnChangedCallback(() => {
      this._setCollection();
      this._changeDetector.detectChanges();
    });
  }

  public open(notification: BcNotification): void {
    if (notification.isClosable) {
      this.remove(notification);
    }
  }

  public remove(notification: BcNotification): void {
    this._notificationService.removeNotification(notification.id);
  }

  public getTypeClass(notification: BcNotification): string {
    switch (notification.type) {
      case NotificationType.Error:
        return 'error';
      case NotificationType.Success:
        return 'success';
    }
  }

  public getClosableClass(isClosable: boolean): string {
    return isClosable ? 'closable-notification' : 'not-closable-notification';
  }

  private _setCollection(): void {
    this.notifications = this._notificationService.getNotifications();
  }
}
